// NPM Imports
import React from "react";
import { Input, Label } from "../../../../revvComponents";

// Components Imports

// Declarations
const FORMAT_OPTIONS = [
  { id: "COMMA", label: "Comma Separated" },
  { id: "BULLET", label: "Bulleted List" },
  { id: "NUMBER", label: "Numbered List" },
];

const FieldFormatOptions = ({
  selectFormat,
  selectedFormat,
  sourceFieldName,
}) => (
  <div className="sourcefieldstransform-formatting-options-wrapper">
    <div className="transform-settings-merge-field-title">Format</div>
    <div className="sourcefieldstransform-formatting-options">
      {FORMAT_OPTIONS.map(option => (
        <Label
          htmlFor={`dsFieldFormatOption_${sourceFieldName}_${option.id}`}
          className="sourcefieldstransform-formatting-inputfield">
          <Input
            id={`dsFieldFormatOption_${sourceFieldName}_${option.id}`}
            name={`dsFieldFormatOption_${sourceFieldName}`}
            data-test={"ds_field_format_option"}
            type={"radio"}
            checked={selectedFormat[sourceFieldName] === option.id}
            onChange={() => selectFormat(option.id, sourceFieldName)}
          />
          <span className="sourcefieldstransform-formatting-options-label">
            {option.label}
          </span>
        </Label>
      ))}
    </div>
  </div>
);

export default FieldFormatOptions;
